// Fixed ordered palette. Consumers should use array order for deterministic
// top-to-bottom colors; when the list exceeds the palette, colors wrap.
export const PALETTE = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#84CC16",
  "#22C55E",
  "#10B981",
  "#14B8A6",
  "#06B6D4",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#A855F7",
  "#D946EF",
  "#EC4899",
  "#F43F5E",
  "#65A30D",
  "#0891B2",
  "#7C3AED",
  "#DB2777",
  "#B45309",
  "#047857",
  "#1D4ED8",
  "#9D174D",
];

export const colorForIndex = (index = 0) =>
  PALETTE[Math.abs(Number(index) || 0) % PALETTE.length];
